import { useEffect } from 'react';

export const ExternalRedirect = ({ to }: { to: string }) => {
    useEffect(() => {
        window.location.href = to;
    }, [to]);

    return null;
};
